module.exports = __webpack_public_path__ + "img/levante.9fa34cf0.svg";